import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { EditIconWrapper } from '../components/EditIcon/styles';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    max-width: 60%;
    width: 100%;

    @media (max-width: 768px) {
        max-width: 100%;
        align-self: center;
    }
`;

export const FieldHolder = styled.div`
    display: flex;
    position: relative;
    align-self: flex-start;

    @media (max-width: 768px) {
        align-self: center;
        width: 100%;
    }
`;

export const ErrorText = styled(motion.div)`
    font-weight: 400;
    line-height: 1;
    color: #ff0000;
    font-size: 12px;
    letter-spacing: -0.6px;
    user-select: none;
    overflow: hidden;
`;

export const TextStyles = styled.div`
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.3px;

    width: 100%;
    position: relative;
    word-break: break-all;
    max-width: 500px;

    display: flex;
    gap: 18px;

    @media (max-width: 768px) {
        max-width: 100%;
    }
`;

export const EditableArea = styled(TextStyles)<{ $isInvalid: boolean }>`
    cursor: text;
    transition:
        padding 0.2s ease-in-out,
        background-color 0.2s ease-in-out,
        color 0.2s ease-in-out,
        max-width 0.2s ease-in-out;
    border-radius: 10px;

    ${EditIconWrapper} {
        top: 3px;
    }

    &:empty:before {
        content: attr(placeholder);
        pointer-events: none;
        display: block;
    }

    &:hover {
        color: #fff;

        ${EditIconWrapper} {
            opacity: 1;
            transform: translateX(0);
        }
    }

    &:focus {
        outline: none;
        background-color: rgba(255, 255, 255, 0.05);
        padding: 10px 14px 12px 14px;
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
        color: #fff;
        max-width: 528px;

        &:empty:before {
            color: rgba(255, 255, 255, 0.5);
        }

        ${EditIconWrapper} {
            display: none;
        }
    }

    ${({ $isInvalid }) =>
        $isInvalid &&
        css`
            outline: none;
            background-color: rgba(255, 255, 255, 0.05);
            padding: 10px 14px 12px 14px;
            box-shadow:
                0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
                0 0 0 1px rgba(255, 255, 255, 0.1) inset;
            color: #fff;
            max-width: 528px;

            &:empty:before {
                color: rgba(255, 255, 255, 0.5);
            }

            ${EditIconWrapper} {
                display: none;
            }
        `}
`;
